module.exports = __webpack_public_path__ + "static/media/instructions-bnx-account-ss.090751ec.png";